import {Inject, Injectable, Pipe, PipeTransform} from '@angular/core';
import {APP_CONFIG, AppConfig} from "../../../config/app.config";

type DateMonthFormat = 'short' | 'long' | 'short-week' | 'long-week' | 'ymd';
@Pipe({
  name: 'dateMonth',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class DateMonthPipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig,) {
  }

  private translates: any = this.appConfig.translates.dates;

  private monthNamesFull = this.translates.monthNamesFull;
  private monthNamesShort = this.translates.monthNamesShort;
  private weekDaysShort = this.translates.weekDaysShort;
  private weekDaysFull = this.translates.weekDaysShort;

  transform(value: string | Date, format: DateMonthFormat = 'long'): string {
    if (!value) return '';
    const date = this.parseDate(value);
    if (!date) return '';

    const day = date.getUTCDate();
    const monthIndex = date.getUTCMonth();
    const weekDayIndex = date.getUTCDay();

    switch (format) {
      case 'short': {
        const month = this.monthNamesShort[monthIndex];
        return `${day} ${month}`;
      }
      case 'short-week': {
        const month = this.monthNamesShort[monthIndex];
        return `${day} ${month}, ${this.weekDaysShort[weekDayIndex]}`;
      }
      case 'long-week': {
        const month = this.monthNamesFull[monthIndex];
        return `${day} ${month}, ${this.weekDaysFull[weekDayIndex]}`;
      }
      case 'ymd': {
        const yyyy = date.getUTCFullYear();
        const mm = String(monthIndex + 1).padStart(2, '0');
        const dd = String(day).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
      case 'long':
      default: {
        const month = this.monthNamesFull[monthIndex];
        return `${day} ${month}`;
      }
    }
  }

  private parseDate(input: string | Date): Date | null {
    if (input instanceof Date) {
      return isNaN(input.getTime()) ? null : input;
    }
    const s = String(input).trim();
    if (!s) return null;

    // DD.MM.YYYY
    const dmy = /^(\d{2})\.(\d{2})\.(\d{4})$/;
    const m1 = s.match(dmy);
    if (m1) {
      const dd = Number(m1[1]);
      const mm = Number(m1[2]); // 1-12
      const yyyy = Number(m1[3]);
      const d = new Date(Date.UTC(yyyy, mm - 1, dd));
      return isNaN(d.getTime()) ? null : d;
    }

    // YYYY-MM-DD
    const ymd = /^(\d{4})-(\d{2})-(\d{2})$/;
    const m2 = s.match(ymd);
    if (m2) {
      const yyyy = Number(m2[1]);
      const mm = Number(m2[2]);
      const dd = Number(m2[3]);
      const d = new Date(Date.UTC(yyyy, mm - 1, dd));
      return isNaN(d.getTime()) ? null : d;
    }

    // Fallback: доверимся Date (ISO, Sat Aug 23 2025 00:00:00 GMT+0500 и т.п.)
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }
}
